import type {Comment, Thread, ThreadSubject} from '@github-ui/diff-lines/conversation-types'

type CommentAuthor = {
  avatarUrl: string
  login: string
}

type CommentPreviews = {
  author?: CommentAuthor | null
}

export type PreviewInfo = {
  threadId: string
  commentId: string
  path: string
  threadPreviewComments: CommentPreviews[]
  originalDiffPathUri?: string | null
  firstComment?: Comment
  subject?: ThreadSubject
  line?: number | null
  isOutdated?: boolean
}

export type ThreadPreview = Pick<Thread, 'isResolved' | 'line' | 'subjectType' | 'subject' | 'commentsData'> & {
  threadId: string
  isOutdated?: boolean
  commentId: string
  path: string
  //TODO: deprecate threadPreviewComments
  threadPreviewComments: CommentPreviews[]
  originalDiffPathUri?: string | null
  firstComment?: Comment
}

export type ThreadPreviewComp = {
  thread?: Thread | null
  previewInfo: PreviewInfo
}

export type ThreadPreviewsPayload = ThreadPreview[]
export type ThreadPreviewsCompPayload = ThreadPreviewComp[]

// Type guard to check if an item is ThreadPreviewComp
export function isThreadPreviewComp(item: unknown): item is ThreadPreviewComp {
  return item !== null && typeof item === 'object' && 'previewInfo' in item
}

// Transform ThreadPreview to ThreadPreviewComp
export function transformThreadPreviewToComp(thread: ThreadPreview): ThreadPreviewComp {
  return {
    thread: {
      id: thread.threadId,
      isResolved: thread.isResolved,
      isOutdated: thread.isOutdated,
      line: thread.line,
      subjectType: thread.subjectType,
      subject: thread.subject,
      commentsData: thread.commentsData,
    },
    previewInfo: {
      threadId: thread.threadId,
      commentId: thread.commentId,
      path: thread.path,
      threadPreviewComments: thread.threadPreviewComments,
      originalDiffPathUri: thread.originalDiffPathUri,
      firstComment: thread.firstComment,
      subject: thread.subject,
    },
  }
}
